import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { PrivacyPolicyValidationService } from '../../../Core/Services';
import { Validation } from '../../../Core/models';
import { Observable } from 'rxjs';
import { TelephoneValidationService } from 'src/app/Core/Services/component/telephone-validation.service';

@Component({
  selector: '[app-privacy-policy]',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.css']
})
export class PrivacyPolicyComponent implements OnInit {
  constructor(private privacyPolicyValidationService: PrivacyPolicyValidationService, public telephoneValidationService: TelephoneValidationService) {
  }
  
  @Output() onSubmit: EventEmitter<boolean> = new EventEmitter<boolean>();
  public errorClass = '';
  public error: Validation = new Validation();
  public isChecked;
  ngOnInit() {
    this.privacyPolicyValidationService.privacyPolicyValid$.subscribe({
      next: (error) => {
        this.error.isInValid = error.isInValid;
        this.error.errorCss = error.errorCss
      }
    })
  }
  submitAnswer() {
    this.onSubmit.emit(this.isChecked);
  }

}
